import { render, staticRenderFns } from "./DialogIcon.vue?vue&type=template&id=22ff5bc5&"
import script from "./DialogIcon.vue?vue&type=script&lang=js&"
export * from "./DialogIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports